import React, { Component } from "react";
import { PageHeader } from "react-bootstrap";
import { Panel,
          Row,
          Col,
          Button,
          FormGroup,
          Tabs,
          Tab,
          FormControl,
          ControlLabel,
          Table,
          Checkbox,
          Glyphicon,
          Modal,
          ButtonGroup,
          DropdownButton,
          MenuItem,
          Tooltip,
          OverlayTrigger} from "react-bootstrap";
import Truncate from 'react-truncate';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {ToastContainer, ToastStore} from 'react-toasts';
import _ from "underscore";
import $ from "jquery";
import moment from 'moment';

//Props:
//element
//selectedIndex
class DetailPanel extends Component {

  constructor(props, context) {
      super(props, context);

      this.state = {
        element: {}
      }

      this.renderFields = this.renderFields.bind(this);
  }

  render() {
    // "width": "12",
    // "fontSize": 12,
    // "orientation": "row", //col or row
    // "label": "Label Here!",
    // "id": "TextInput_"+new Date().getTime(),

    return <Row>
              <Col style={{maxHeight: 500, overflow: "scroll"}}>
                {this.props.element != null
                    ? this.renderFields()
                    : this.renderPlaceHolder()}
              </Col>
            </Row>;
  }

  componentDidMount() {
    this.setState({
      element: this.props.element
    })
  }
  componentDidUpdate(prevProps) {

    if(JSON.stringify(prevProps) !== JSON.stringify(this.props) || this.state.element == {}) {
      this.setState({
        element: this.props.element ? this.props.element : {}
      })
    }
  }

  renderFields() {
    var fields = [];
    var ignoredKeys = ["type", "value", "children","parentElement", "isClone"];
    Object.keys(this.props.element).map((key)=>{
      if(ignoredKeys.indexOf(key) < 0) {
        if(this.props.element[key].editorFieldType == null) {
          fields.push(<FormGroup controlId={key} bsSize="md" style={{padding: 2}} className={"col-md-12"}>
                          <ControlLabel className="login_label">{key} {this.props.element[key] && this.props.element[key].toolTip ? this.renderToolTip(this.props.element[key].toolTip) : null}</ControlLabel>
                          <FormControl
                              autoFocus
                              type="text"
                              value={this.props.element[key].value != null ? this.props.element[key].value : this.props.element[key]}
                              onChange={(e)=>{this.updateElement(key, e.currentTarget.value)}}
                          />
                      </FormGroup>)
        } else {
          switch(this.props.element[key].editorFieldType) {
            case "dropDown":
              fields.push(<FormGroup controlId={key} bsSize="md" style={{padding: 2}} className={"col-md-12"}>
                            <ControlLabel className="control-label">Button Type</ControlLabel>
                            <FormControl  componentClass="select"
                                          defaultValue={"select"}
                                          value={this.props.element[key].value}
                                          onChange={(e)=>{
                                              var newElement = JSON.parse(JSON.stringify(this.props.element));
                                              newElement[key].value = e.currentTarget.value;

                                              this.updateElement(key + ".value", e.currentTarget.value )
                                              // this.props.updateElement(this.props.selectedIndex, newElement, newElement.parentElement);

                                              if(newElement.buttonType.specialType == "dropDownChoice" && e.currentTarget.value == "Default") {
                                                  setTimeout(()=>{this.updateChoiceList([], "choices");}, 500)
                                              }

                                            }}>
                                {this.props.element[key].list.map((option, index) => {
                                            return <option key={index} value={option}>{option}</option>
                                          })
                                }
                            </FormControl>
                          </FormGroup>)
            break;

            case "list":
            var disabledNewChoice = false;
            var choices = [];
            if(this.props.element.buttonType.value !== "Default") {
              disabledNewChoice = true;
              switch(this.props.element.buttonType.value) {
                case "Client":
                  choices = this.repackForChoices(this.props.clients, "client");

                break;
                default:

                break;
              }

              if(JSON.stringify(this.props.element[key].value) !== JSON.stringify(choices) ) {
                setTimeout(()=>{
                  this.updateChoiceList(choices, "choices");
                }, 1000)

              }
            } else {
              choices = this.props.element[key].value;
            }
              fields.push(<FormGroup controlId={key} bsSize="md" style={{padding: 2, border: "solid", borderWidth: 0.2}} className={"col-md-12"}>
                              <ControlLabel className="login_label">{key} {this.props.element[key] && this.props.element[key].toolTip ? this.renderToolTip(this.props.element[key].toolTip) : null}</ControlLabel>
                              <FormControl
                                  autoFocus
                                  type="text"
                                  disabled={disabledNewChoice}
                                  value={this.props.element[key].newChoice}
                                  onChange={(e)=>{this.updateElement("choices.newChoice", e.currentTarget.value)}}
                              />

                              <br/>
                              <Button
                              disabled={disabledNewChoice}
                                onClick={()=>{this.addToChoiceList(choices, this.props.element[key].newChoice, "choices") }}>Add To Choices</Button>
                              <br/>
                              <Col style={{maxHeight: 300, overflow: "scroll"}}>
                                {
                                  choices.map((choice, index)=>{
                                    return <Row key={index}>{choice.name} {this.renderDeleteButton(this.props.element[key].value, choice, key)}</Row>
                                  })
                                }
                              </Col>
                          </FormGroup>)
            break;
          }
        }

      }
    });

    return fields;
  }

  renderPlaceHolder() {
    return <div>No Form Field Selected</div>
  }

  updateElement(field, value) {
    var newElement = JSON.parse(JSON.stringify(this.props.element));

    var splitField = field.split(".");
    var field2 = "";
    if(splitField.length > 1) {
      field = splitField[0];
      field2 = splitField[1];
    }
    if(splitField.length > 1) {
        newElement[field][field2] = value;
    } else {
      if(newElement[field].value == null) {
          newElement[field] = value;
      } else {
        newElement[field].value = value;
      }
    }
    var customParentElement = null;
    var newChildren = [];

    if(newElement.parentElement != null) {
      customParentElement = JSON.parse(JSON.stringify(newElement.parentElement));
      customParentElement.children.splice(this.props.selectedIndex, 1, newElement);
    }

    // this.setState({
    //   element: newElement
    // });

    this.props.updateElement(this.props.selectedIndex, newElement, customParentElement);
  }

  renderToolTip(toolTip) {
  return  <OverlayTrigger
            placement="top"
            delay={200}
            overlay={<Tooltip id="overlay-example">
                              {toolTip}
                    </Tooltip>}>
             <Glyphicon glyph="info-sign"
                style={{marginLeft: 15, cursor: "pointer", marginTop: "5%"}}/>
            </OverlayTrigger>
  }

  renderDeleteButton(list, listItem, field) {
    return (<OverlayTrigger
              placement="top"
              delay={200}
              overlay={<Tooltip id="overlay-example">
                                {"Delete this from list"}
                      </Tooltip>}>
               <Glyphicon glyph="remove"
                  style={{marginLeft: 15, cursor: "pointer", marginTop: "5%"}}
                  onClick={()=>{
                    var newList = list.slice();
                    newList.splice(newList.indexOf(listItem), 1);
                    this.updateElement(field, newList.slice());
                  }}/>
              </OverlayTrigger>);
  }

  addToChoiceList(list, listItem, field) {
    var newList = list.slice();
    newList.push({id: listItem + "_" + new Date().getTime(), name: listItem});
    this.updateChoiceList(newList, field);

  }

  updateChoiceList(list, field) {
    var newList = list.slice();
    this.updateElement(field, newList.slice());
  }

  repackForChoices(items, type) {

    var newItems = [];
    switch(type) {
      case "client":
        items.map((item)=>{
          if(item.is_active) {
              newItems.push({id: item.id, name: item.client_name});
          }

        });
      break;
    }

    return newItems;
  }

}

export default DetailPanel;
